var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sticky-panel grid grid__custom-1", class: _vm.rootClasses },
    [
      _c("div", { staticClass: "sticky-panel--wrap", style: _vm.wrapStyle }, [
        _c("div", { staticClass: "grid--container" }, [
          _c("div", { staticClass: "grid--row" }, [
            _c(
              "div",
              { ref: "content", staticClass: "sticky-panel--col grid--col" },
              [
                _c(
                  "div",
                  { staticClass: "sticky-panel--main" },
                  [
                    _vm._t("default", null, {
                      items: _vm.items,
                      scrollTo: _vm.scrollTo,
                      activeSubtitleIndex: _vm.activeSubtitleIndex
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.$scopedSlots.footer
                  ? _c(
                      "div",
                      { staticClass: "sticky-panel--footer" },
                      [_vm._t("footer")],
                      2
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c949e78", { render: render, staticRenderFns: staticRenderFns })
  }
}